import React from 'react';
import { useState, useEffect, useRef } from 'react';
import bluedownarrow from '../../images/common/bluedownarrow.png'
import blueuparrow from '../../images/common/blueuparrow.png'
import '../../scss/reusables/dropdown.scss'
import greydownarrow from '../../images/common/greydownarrow.png';
import search from '../../images/common/search.png';
import { ListGroup } from 'react-bootstrap';
import { IoIosArrowDown } from "react-icons/io";

function ClickOutside(ref, setDropdownCliked) {

    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownCliked(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function Dropdown({selectedItem, label, list, handleLabel, enable, searchbar, customSearchBar, searchQuery, setSearchQuery, searchPlaceholder}) {
    const [searchData, setSearchData] = useState(null);
    const [dropdownList, setDropdownList] = useState([]);
    const [searchList, setSearchList] = useState([]);

    const dropdownwrapperRef = useRef(null);
    const [isDropdownCliked, setDropdownCliked] = useState(false);
    ClickOutside(dropdownwrapperRef, setDropdownCliked);

    const handleDropdown = () => {
        setDropdownCliked(!isDropdownCliked);
    }

    const dropdownSelect = (name, id) => {
        selectedItem(name, id);
        handleLabel(name);
        setDropdownCliked(!isDropdownCliked);
    }

    const handleSearchData = (query) => {
        setSearchData(query);
    }

    const handleEnterkey = (key) => {
        if (key == 'Enter') {
            setSearchData(searchData);
        }
    }

    useEffect(() => {
        setDropdownList(list);
        setSearchList(list);
    }, [list])

    useEffect(() => {
        let suggestions = [];
        if(searchData != null) {
            dropdownList.length > 0 && dropdownList.map((item) => {
                if(item.name.toLowerCase().includes(searchData.toLowerCase())) {
                    suggestions.push(item)
                }
            })
            setSearchList(suggestions);
        }
    }, [searchData])

    useEffect(() => {
        if(!isDropdownCliked) {
            setSearchQuery && setSearchQuery("");
        }
    }, [isDropdownCliked])
    
    return (
        <div className={`${enable ? 'dropdown' : 'dropdown dropdown-grey-shadow'}`} ref={dropdownwrapperRef}>
            <div className='dropdown-name-img' onClick={handleDropdown}>
                <div className={`${enable ? 'dropdown-name' : 'dropdown-name grey-label'}`}>{label}</div>
                <IoIosArrowDown size={20} style={{transform: isDropdownCliked ? 'rotate(180deg)' : '', color: enable ? '#059CDC' : '#BABABA'}} />
            </div>
            {isDropdownCliked && (
                <>
                    {searchbar && 
                    <div className='dropdown-search'>
                        <div className='dropdown-search-container'>
                            <input type="text" value={searchData} placeholder="Search Property" onChange={(e) => handleSearchData(e.target.value)}
                                onKeyDown={(e) => handleEnterkey(e.key)}></input>
                            <img src={search} alt="searchicon" onClick={() => handleSearchData(searchData)}></img>
                        </div>
                    </div>}

                    {customSearchBar && <CustomSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} placeholder={searchPlaceholder}/>}
                    <div className='dropdown-list'>
                        {searchList.length > 0 && searchList.map((item, index) => {
                            return (
                                <>
                                    <div className='dropdown-content-inner' key={item.id} onClick={() => dropdownSelect(item.name, item.id)}>{item.name}</div>
                                </>
                            )
                        })}
                    </div>
                </>
            )}
            </div>
        );
    }

export default Dropdown;

function CustomSearchBar ({searchQuery, setSearchQuery, placeholder}) {
    console.log('searchQuery', searchQuery);
    const handleEnterkey = (key) => {
        if (key == 'Enter') {
            setSearchQuery(searchQuery);
        }
    }
    return (
        <div className='dropdown-search'>
            <div className='dropdown-search-container'>
                <input type="text" value={searchQuery} placeholder={placeholder} onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => handleEnterkey(e.key)}></input>
                <img src={search} alt="searchicon"></img>
            </div>
        </div>
    )
}